// selectPath.js
'use strict';

export const list = {
  /**
   * get leaderboard list select path
   * @param {object} payload - payload.
   * @param {string} payload.region - leaderboard region.
   * @param {string} payload.category - leaderboard category.
   * @param {string} payload.range - leaderboard range.
   * @return {string[]} select path
   */
  leaderboard: ({ region, category, range }) => [
    'leaderboards',
    region,
    category,
    range,
  ],
};

export const networking = {
  /**
   * get leaderboard networking select path
   * @param {object} payload - payload.
   * @param {string} payload.region - leaderboard region.
   * @param {string} payload.category - leaderboard category.
   * @param {string} payload.range - leaderboard range.
   * @param {number} payload.page - leaderboard page.
   * @return {string[]} select path
   */
  leaderboard: ({ region, category, range, page }) => [
    'leaderboards',
    region,
    category,
    range,
    page,
  ],
};

export default {
  list,
  networking,
};
